import ProviderPicker from 'components/ProviderPicker'
import InventoryLocationPicker from 'components/InventoryLocationPicker'
import { TransactionType, Provider } from 'graphql'
import { isFromProvider, isFromStore } from 'graphql/utils/transaction-types'
import { EuiFormRowProps } from '@equipmentshare/ds2'
import { InventoryLocation } from 'inventory-web'

export type FromEntityType = Provider | InventoryLocation | null

export type FromEntityProps = {
	type: TransactionType,
	selectedItem?: FromEntityType,
	selectedItemId?: number,
	onChange: ( id: number, item?: FromEntityType ) => void,
	formRowProps?: Partial<EuiFormRowProps>,
}

export default function FromEntity( { type, onChange, selectedItem, selectedItemId, formRowProps }: FromEntityProps ) {
	if ( isFromProvider( type ) ) {
		return (
			<ProviderPicker
				label="From Manufacturer"
				onChange={onChange}
				selectedProvider={selectedItem as Provider}
				formRowProps={formRowProps}
				isInvalid={formRowProps?.isInvalid}
			/>
		)
	}

	if ( isFromStore( type ) ) {
		return (
			<InventoryLocationPicker
				label="From Store"
				onChange={onChange}
				selectedInventoryLocation={selectedItem as InventoryLocation}
				selectedInventoryLocationId={selectedItemId}
				formRowProps={formRowProps}
				isInvalid={formRowProps?.isInvalid}
			/>
		)
	}

	return null
}
